function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { memo, useCallback, useMemo, useState } from 'react';
import { useRefCallback } from '@bydesign-ui/hooks';
import { usePrefixCls } from '@byte-design/config';
import { classnames } from '@bydesign-ui/utils';
import { RangeState } from '../../hooks/date';
import { ViewCol, ViewGrid, ViewRow, useDateState } from '../../units/date';
import { getPresetsMatrix } from './util';
import DynamicDatePreview from './DynamicDatePreview';
import { DynamicDateCustomize } from './DynamicDateCustomize';

function DynamicDateViewItem(props) {
  var disabled = props.disabled,
      item = props.item,
      prefix = props.prefix,
      selected = props.selected,
      onSelect = props.onSelect;
  var cls = classnames(usePrefixCls(prefix, {
    item: true,
    dynamic: true
  }, true), useDateState(prefix, {
    selectedState: selected ? RangeState.SINGLE : RangeState.NONE,
    gridState: RangeState.IN,
    disabledState: disabled ? RangeState.SINGLE : RangeState.NONE
  }));
  var onSelectCallback = useRefCallback(onSelect);
  var handleClick = useCallback(function () {
    if (!disabled) {
      onSelectCallback(item);
    }
  }, [item, disabled]);
  return React.createElement("div", {
    className: cls,
    onClick: handleClick
  }, item.label);
}

var MemoDynamicDateViewItem = memo(DynamicDateViewItem);
export function DynamicDateView(props) {
  var categories = props.categories,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      fixedValue = props.fixedValue,
      _props$onlyShowStart = props.onlyShowStart,
      onlyShowStart = _props$onlyShowStart === void 0 ? false : _props$onlyShowStart,
      _props$prefix = props.prefix,
      prefix = _props$prefix === void 0 ? 'date' : _props$prefix,
      presets = props.presets,
      value = props.value,
      _props$wider = props.wider,
      wider = _props$wider === void 0 ? false : _props$wider,
      onChange = props.onChange;
  var cls = classnames(usePrefixCls('dynamic-date-view', {
    wider: wider
  }), className);
  var categoryCls = classnames(usePrefixCls('date-col'), usePrefixCls('dynamic-date-category'));

  var _useState = useState(value && !value.key),
      _useState2 = _slicedToArray(_useState, 2),
      customizeEnabled = _useState2[0],
      setCustomizeEnabled = _useState2[1];

  var onChangeCallback = useRefCallback(onChange);
  var handleChange = useCallback(function (val) {
    if (customizeEnabled) {
      setCustomizeEnabled(false);
    }

    onChangeCallback(val);
  }, [customizeEnabled, setCustomizeEnabled]);
  var matrix = useMemo(function () {
    return getPresetsMatrix(presets, categories);
  }, [presets, categories]);
  var maxLength = useMemo(function () {
    return Math.max.apply(Math, _toConsumableArray(matrix.map(function (r) {
      return r.length;
    })));
  }, [matrix]);
  return React.createElement("div", {
    className: cls
  }, React.createElement(DynamicDatePreview, {
    fixedValue: fixedValue,
    onlyShowStart: onlyShowStart
  }), React.createElement(ViewGrid, {
    prefix: prefix,
    type: "dynamic-date",
    position: RangeState.SINGLE
  }, matrix.map(function (row, rIdx) {
    return React.createElement(ViewRow, {
      prefix: prefix,
      key: categories[rIdx].key,
      type: "dynamic-date"
    }, React.createElement("div", {
      className: categoryCls
    }, categories[rIdx].label), row.map(function (col) {
      return React.createElement(ViewCol, {
        enableInvalidTooltip: false,
        prefix: prefix,
        type: "dynamic-date",
        key: col.key
      }, React.createElement(MemoDynamicDateViewItem, {
        prefix: prefix,
        item: col,
        disabled: disabled,
        selected: col.key === (value === null || value === void 0 ? void 0 : value.key),
        onSelect: handleChange
      }));
    }), Array(maxLength - row.length).fill(0).map(function (_, cIdx) {
      return React.createElement(ViewCol, {
        enableInvalidTooltip: false,
        prefix: prefix,
        type: "dynamic-date",
        key: "".concat(categories[rIdx].key).concat(cIdx)
      });
    }));
  })), React.createElement(DynamicDateCustomize, {
    disabled: !customizeEnabled,
    disabledCheckMark: disabled,
    initialValue: value,
    onlyShowStart: onlyShowStart,
    onChange: onChangeCallback,
    onDisabledChange: setCustomizeEnabled
  }));
}